var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"comments"}}),_c('a',{attrs:{"id":"mc-link","href":"http://cackle.me"}},[_vm._v("\n    Комментарии для сайта "),_c('b',{staticStyle:{"color":"#4fa3da"}},[_vm._v("Cackl")]),_c('b',{staticStyle:{"color":"#f65077"}},[_vm._v("e")])])])
}]

export { render, staticRenderFns }